(function () {
    "use strict";

    // @ngInject
    function CompanySettingsWidgetControllerCtor(UsersManager) {
        this.user = UsersManager.getCurrUser();
    }


    Controllers.CompanySettingsWidgetController = Class(Controllers.BaseController, {

        constructor: CompanySettingsWidgetControllerCtor

    });

}());